import type { FaireProductEntity } from "../../entity_types/product";

export const p_dq76w2zg6a: FaireProductEntity = {
  token: "p_dq76w2zg6a",
  type: "product",
  name: "Buena Vista Dark Roast",
  brandToken: "b_d3mdkn2j3h",
  brandName: "Verve Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/b588fe5b22809b245ddf866079ebfddffae84f116f2db6341b16aa3c896401f2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/58b99fe55588fa7332721ebfd5ec4c8b88a98b10b0d348d7ce153abe713ac129.png",
    "https://cdn.faire.com/fastly/47b19886eeeb31e244adbc7b8908cd354f2fb315d2b9aa2dbb14e5ea51a150c3.png"
  ],
  priceDollars: 79,
  description: "A chocolatey maple sweetness is joined by a juicy, red apple flavor in one of our flagship dark roast blends. Characterized by its deep structure and full body, Buena Vista Dark Roast is an excellent choice for anyone who enjoys adding cream to coffee.\n\n𝐑𝐨𝐚𝐬𝐭 𝐋𝐞𝐯𝐞𝐥\n\n• Coffee Details Country\nColombia\n𝐓𝐚𝐬𝐭𝐢𝐧𝐠 𝐍𝐨𝐭𝐞𝐬\nChocolate, Red Apple, Maple\n𝐏𝐫𝐨𝐝𝐮𝐜𝐞𝐫\nVarious Producers\n\n𝐏𝐫𝐨𝐜𝐞𝐬𝐬\nWashed\n\n𝐄𝐥𝐞𝐯𝐚𝐭𝐢𝐨𝐧\n1,700 - 2,000 Meters\n\n𝐇𝐚𝐫𝐯𝐞𝐬𝐭\nNovember - March\n\n𝐁𝐫𝐞𝐰 𝐌𝐞𝐭𝐡𝐨𝐝\nFrench Press\n\n𝐁𝐫𝐞𝐰 𝐑𝐚𝐭𝐢𝐨\n1:16\n\n𝐁𝐫𝐞𝐰 𝐑𝐞𝐜𝐢𝐩𝐞\nCoffee: 43 grams\nWater: 700 grams\nBrew Time: 4:00 minutes\n\n• Farmlevel Story\nFarmlevel\n\nCoffee arrives at our roastery in the form of a dried green seed found formerly in the center of a tropical cherry.",
  tags: [],
  msrpDollars: 158,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:55.481Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
